export const SITE_LINKS = {
  ActivityPage: (lessonId?: string) => `/v4/activity?lessonId=${lessonId}`,
  ForgotUsernamePage: `/forgot-username`,
  ForgotUsernameSuccessPage: `/forgot-username-success`,
  HelpPage: `/v4/help`,
  HomePage: '/v4',
  LessonPage: (levelPosition?: number, unitPosition?: number, lessonPosition?: number) =>
    `/v4/level/${levelPosition}/unit/${unitPosition}/lesson/${lessonPosition}`,
  LessonIndexPage: `/v4/progress/index`,
  LevelDetailsPage: (level?: number) => `/v4/level${level ? '/' + level : ''}`,
  LevelsPage: `/v4/levels`,
  LiveClassHistoryPage: `/v4/progress/lc-history`,
  LoginPage: `/login`,
  Logout: `/logout`,
  OnboardingPage: (step?: string) => `/v4/onboarding-${step}`,
  PlacementTestPage: `/v4/placement-test`,
  PlacementTestIntroductionPage: `/v4/placement-test/intro`,
  PlacementTestPlayerPage: `/v4/placement-test/player`,
  PlacementTestResultPage: `/v4/placement-test/result`,
  ProfilePage: `/v4/profile`,
  ResetPasswordPage: `/forgot-password`,
  ResetPasswordSuccessPage: `/forgot-password-success`,
  ResetPasswordSubmissionSuccessPage: `/forgot-password-submission-success`,
  Share: `/v4/share`,
  UnitPage: (level?: number, unit?: number | string) => `/v4/level/${level}/unit/${unit}`,
  EndOfLevelTest: (level?: number) => `/v4/level/${level}/eol`,
  PreClassActivityPage: '/v4/preclass-activity',
};
